import { Component, inject, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { EEntityType, ERelationType } from '@web/dtos';
import {
  ButtonGroupComponent,
  IButtonOption,
} from '../../../../../components/data-input/form-inputs/button-group/button-group.component';
import { ImageSelectComponent } from '../../../../../components/data-input/form-inputs/image-select/image-select.component';
import { TextInputComponent } from '../../../../../components/data-input/form-inputs/text-input/text-input.component';
import { TranslationAccessibilityTextInputComponent } from '../../../../../components/data-input/form-inputs/translation-accessibility-text-input/translation-accessibility-text-input.component';
import { ButtonComponent } from '../../../../../components/feedback/button/button.component';
import { IFooterBlockForm } from '../../../../../entities/footer-entity';
import { ImageFormsFactoryService } from '../../../../../factory/image/image-forms-factory.service';
import { CmsTextProviderService } from '../../../../../services/cms-text-provider.service';

@Component({
  selector: 'aw-footer-images-block-editor',
  imports: [
    ReactiveFormsModule,
    ButtonGroupComponent,
    ImageSelectComponent,
    TextInputComponent,
    TranslationAccessibilityTextInputComponent,
    ButtonComponent,
  ],
  templateUrl: './footer-images-block-editor.component.html',
})
export class FooterImagesBlockEditorComponent {
  readonly block = input.required<FormGroup<IFooterBlockForm>>();
  readonly index = input.required<number>();

  protected readonly cmsTextProvider = inject(CmsTextProviderService);
  protected readonly EntityType = EEntityType;
  protected readonly TextRelationType = ERelationType;
  private readonly imageFormsFactory = inject(ImageFormsFactoryService);
  protected readonly orientationOptions: IButtonOption<
    'vertical' | 'horizontal'
  >[] = [
    { label: 'Vertikal', value: 'vertical' },
    { label: 'Horizontal', value: 'horizontal' },
  ];

  protected addImage(): void {
    const images = this.block().controls.accessibleImages;
    images.push(
      this.imageFormsFactory.buildImageFormGroup(undefined, images.length)
    );
    this.block().markAsDirty();
  }

  protected removeImage(index: number): void {
    this.block().controls.accessibleImages.removeAt(index);
    this.updatePositions();
  }

  protected moveImage(index: number, direction: -1 | 1): void {
    const images = this.block().controls.accessibleImages;
    const target = index + direction;
    if (target < 0 || target >= images.length) return;

    const image = images.at(index);
    images.removeAt(index, { emitEvent: false });
    images.insert(target, image, { emitEvent: false });
    this.updatePositions();
  }

  private updatePositions(): void {
    const images = this.block().controls.accessibleImages;
    images.controls.forEach((image, index) =>
      image.controls.positionOrder.setValue(index, { emitEvent: false })
    );
    images.updateValueAndValidity();
    this.block().markAsDirty();
  }
}
